import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormatSearchResultsReturn } from '@twiliointernal/e2-commons-shared-definitions';

export const SEARCH_RESULTS_FEATURE_KEY = 'searchResults';

export interface SearchResultsState {
  data?: FormatSearchResultsReturn;
}

export const initialSearchResultsState: SearchResultsState = {};

export const searchResultsSlice = createSlice({
  name: SEARCH_RESULTS_FEATURE_KEY,
  initialState: initialSearchResultsState,
  reducers: {
    reset: (state) => {
      state = initialSearchResultsState;
    },
    set: (state, action: PayloadAction<FormatSearchResultsReturn>) => {
      state.data = action.payload;
    },
    update: (state, action: PayloadAction<Partial<SearchResultsState>>) => {
      const searchResultsData = state.data as SearchResultsState;
      Object.assign(searchResultsData, action.payload);
    },
  },
});

export const searchResultsReducer = searchResultsSlice.reducer;
export const searchResultsActions = searchResultsSlice.actions;

export const selectAllSearchResultsState = (
  rootState: unknown,
): SearchResultsState => {
  if (
    Object.prototype.hasOwnProperty.call(rootState, SEARCH_RESULTS_FEATURE_KEY)
  ) {
    return (rootState as { [SEARCH_RESULTS_FEATURE_KEY]: SearchResultsState })[
      SEARCH_RESULTS_FEATURE_KEY
    ];
  }
  return {} as SearchResultsState;
};

export const selectSearchResultsData = (
  rootState: unknown,
): FormatSearchResultsReturn | undefined =>
  selectAllSearchResultsState(rootState).data;
